var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoDi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2532.71 1254.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-2,.cls-3{fill-rule:evenodd;}.cls-3{fill:#878787;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "co_di") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 1084.83,
    cy: 906.23,
    rx: 338.25,
    ry: 346.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M647.52,1003.53A281.09,281.09,0,0,1,446,1088.31c-155.73,0-282-126.25-282-282s126.25-282,282-282a281.12,281.12,0,0,1,201.08,84.31L732.5,466.44A444.2,444.2,0,0,0,446,362.25c-246.31,0-446,199.68-446,446s199.68,446,446,446a444.22,444.22,0,0,0,289.08-106.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1777.33,369.55a439.12,439.12,0,0,0-50.27,2.89H1525v861.21h304.08c215.07-25.58,381.84-208.57,381.84-430.52C2210.9,563.67,2016.78,369.55,1777.33,369.55Zm0,692.63h-82.62V544h82.62c143.08,0,259.08,116,259.08,259.08S1920.41,1062.18,1777.33,1062.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2307.75,
    y: 591.98,
    width: 166.77,
    height: 641.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2397.22,260a136.39,136.39,0,0,0-28,2.91C2209.11,77.26,1958.55-27.34,1692.83,6.22c-393.64,49.71-679.72,384.86-667,764.81a147.38,147.38,0,1,0,130.21,5.31c-16-319.21,222.74-602.63,552.65-644.29,221.06-27.92,429.49,59.48,562.16,214.42h0A135.51,135.51,0,1,0,2397.22,260Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoDi);
export default __webpack_public_path__ + "static/media/co_di.b2f27495092b554784b119f92e81bb4c.svg";
export { ForwardRef as ReactComponent };